import React from 'react';
import { useTranslation } from 'react-i18next';
import './MarineDilemmaSection.css'; // We'll create this CSS file next

function MarineDilemmaSection() {
  const { t } = useTranslation();

  const points = [
    {
      imgSrc: '/images/marinedilemma/repair.svg',
      textKey: 'marineDilemmaPointNew1',
      defaultText: 'Propellers break on landing (stones/sand) and get blocked by seagrass',
      altKey: 'marineDilemmaAltNew1',
      defaultAlt: 'Illustration of a damaged propeller'
    },
    {
      imgSrc: '/images/marinedilemma/deadly.svg', 
      textKey: 'marineDilemmaPoint1',
      defaultText: 'Propellers injure and kill people and marine life',
      altKey: 'marineDilemmaAlt1',
      defaultAlt: 'Illustration of a propeller and marine life'
    },
    {
      imgSrc: '/images/marinedilemma/loud.svg', 
      textKey: 'marineDilemmaPoint2',
      defaultText: 'Noise and CO₂ from boats are increasingly untenable',
      altKey: 'marineDilemmaAlt2',
      defaultAlt: 'Illustration of a boat emitting noise and CO2'
    },
    {
      imgSrc: '/images/marinedilemma/forbidden.svg', 
      textKey: 'marineDilemmaPoint3',
      defaultText: 'Worldwide regulations to ban gas boat engines starting already',
      altKey: 'marineDilemmaAlt3',
      defaultAlt: 'Illustration of a crossed-out boat engine'
    }
  ];

  return (
    <section id="marine-dilemma" className="marine-dilemma-section content-panel">
      <div className="marine-dilemma-content-container">
        <h1 className="marine-dilemma-headline">
          {t('marineDilemmaHeadline', 'THE MARINE DILEMMA')}
        </h1>
        <ul className="marine-dilemma-points">
          {points.map((point, index) => (
            <li key={index} className="marine-dilemma-point">
              <img 
                src={point.imgSrc} 
                alt={t(point.altKey, point.defaultAlt)} 
                className="marine-dilemma-point-icon" 
              />
              <span>{t(point.textKey, point.defaultText)}</span>
            </li>
          ))}
        </ul>
        <p className="marine-dilemma-solution-statement">
          {t(`marineDilemmaSolutionStatement`, `The world needs a cleaner, safer maritime solution – and that's where we come in`)}
        </p>
      </div>
      <img 
        src="/images/marinedilemma/seabed.png" 
        alt={t('marineDilemmaSeabedAlt', 'Illustration of a seabed with some marine life and litter')} 
        className="marine-dilemma-seabed-image" 
      />
    </section>
  );
}

export default MarineDilemmaSection; 